import { AlertTypes } from "../../../../constants/alert_types";
import BaseAlertsTable from './base-alert-table';
import UtilsService from "../../../../services/UtilsService";

import { mapState, mapActions } from 'vuex';
import { AlertStatuses } from "../../../../constants/alert_statuses";

export default {
  name: 'AlertsTable',
  props: { searchText: String, tableTitle: String, selectedFilter: Object },
  components: { BaseAlertsTable },

  computed: {
    ...mapState({
      actualAlerts(state) {
        return this.tableData(state.alerts.actualAlerts, state.alerts.lastHeats);
      },
      earlierAlerts(state) {
        return this.tableData(state.alerts.earlierAlerts);
      }
    })
  },
  watch: {
    actualAlerts: function (newVal) {
      this.updateCowList(newVal, this.earlierAlerts);
    },
    earlierAlerts: function (newVal) {
      this.updateCowList(this.actualAlerts, newVal);
    }
  },
  methods: {
    ...mapActions("cows", {
      setCowList: "setCowList",
    }),
    /**
     * The computed data for the table
     * @param {object} state The state object
     */
    tableData(data, last_heats) {
      if (last_heats) {
        last_heats.forEach(heat => {
          const cow = data.find(alert => alert.cow_id === heat.cow_id);
          if (cow)
            cow.last_heat = heat.last_heat;
        });
      }
      const formattedData = this.formatData(data);
      const filteredData = this.filterData(this.selectedFilter, formattedData);
      const searchedData = this.searchData(this.searchText, filteredData);
      return searchedData;
    },

    /**
     * Format data from store to displaying
     * @param {array} data The raw data from store to format
     */
    formatData(data) {
      const alertsWithConfirmAction = [
        AlertTypes.Heat,
        AlertTypes.RepeatHeat
      ]

      const alertTypes = [
        AlertTypes.Heat,
        AlertTypes.RepeatHeat,
        AlertTypes.HighTemp,
        AlertTypes.LowTemp,
        AlertTypes.LowWaterIntake,
        AlertTypes.IncreasedActivity,
        AlertTypes.DecreasedActivity,
        AlertTypes.Calving
      ]

      // Filter to only events with existing cow
      return data.filter(({ type, alert_id, cow }) => alertTypes.includes(type) && alert_id && cow)
        .map(alert => {
          // Special case for calving
          let nameIndex = `cowGenerics.cowLogs.${alert.type}`;
          if (alert.type === AlertTypes.Calving)
            nameIndex += "(Alert)";

          const isActive = alert.status == AlertStatuses.active;
          const hasInseminationWindow = [AlertTypes.Heat, AlertTypes.RepeatHeat].includes(alert.type) && isActive;
          const lastHeat = hasInseminationWindow ? UtilsService.lastHeat(alert) : '';

          return {
            id: alert.alert_id,
            cow_id: alert.cow_id,
            type: alert.type,
            status: alert.status,
            date: this.$moment(alert.alert_time),
            nameToDisplay: this.$t(nameIndex),
            dateToDisplay: this.$moment(alert.alert_time).format(this.$dateFormat),
            timeToDisplay: this.$moment(alert.alert_time).format('HH:mm'),
            alertTime: this.$moment(alert.alert_time),
            eartag: alert.cow && alert.cow.eartag,
            barn: alert.cow && alert.cow.building && alert.cow.building.building_name,
            dim: alert.cow && alert.cow.last_calving && UtilsService.get_dim(alert.cow.last_calving),
            lastInsemination:
              alert.cow && alert.cow.last_insemination &&
              this.$moment(alert.cow.last_insemination).format(this.$dateFormat),
            birthDate: alert.cow && alert.cow.birthDate,
            isActive: isActive,
            hasInseminationWindow: hasInseminationWindow,
            isAcknowledgable: [AlertTypes.IncreasedActivity, AlertTypes.DecreasedActivity, AlertTypes.LowWaterIntake,
              AlertTypes.HighTemp, AlertTypes.LowTemp].includes(alert.type) && isActive,
            confirmLocale: [AlertTypes.Heat, AlertTypes.RepeatHeat].includes(alert.type) ? 'heat' : alert.type === AlertTypes.Calving ? 'calving' : undefined,
            lastHeat: lastHeat,
            // for neighbour
            cow: alert.cow
          }
        });
    },

    /**
     * Filter the data for the given stateID
     * @param {Object} filter The StateID filter
     * @param {array} data The data to filter by
     */
    filterData(filter, alerts) {
      if (!filter || !filter.filter) {
        return alerts;
      }
      return alerts.filter(alert => alert.type === filter.filter);
    },

    /**
     * Filters the data wheter it contains the given string
     * @param {string} searchText The raw string typed in the search box
     * @param {array} data The data to search the given string in
     */
    searchData(searchText, data) {
      if (!searchText || searchText === '') {
        return data;
      }
      const searchTextLowcase = searchText.toLowerCase();
      const searchedData = [];
      data.forEach(d => {
        if (
          Object.values(d).some(
            element =>
              element &&
              element
                .toString()
                .toLowerCase()
                .includes(searchTextLowcase)
          )
        ) {
          searchedData.push(d);
        }
      });
      return searchedData;
    },
    updateCowList(actAlerts, earlierAlerts) {
      this.setCowList([...actAlerts.concat(earlierAlerts)].map(alert => ({ ...alert.cow, alert_id: alert.id })));
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/alerts/table/alerts-table.js